import type { IconSvgObject } from './types';

const ChartMaximumIcon: IconSvgObject = [
  ["path", { d: "M21 21H5C3.89543 21 3 20.1046 3 19V3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19 17C19 10.3726 16.3137 5 13 5C9.68629 5 7 10.3726 7 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChartMaximumIcon;
